<template>
  <div v-if="isParts">
    <div style="text-align: left; margin: 16px 0px 0px 16px;">
      全パーツ数：{{scenarioTable.length}}<br>確定パーツ数：{{countConfirmAll(scenarioTable)}}
    </div>
    <template v-for="card in cardList">
      <div class="card body-setting-template"
        :key="card.index"
        draggable="true"
        @dragstart="$emit('dragScenarioParts', card.index)"
        @dragend="$emit('resetDrag')"
        v-if="!roboLock"
      >
        <div>
          <div class="card-header">
            <p class="parts-name">{{card.name}}</p>
          </div>
          <div class="card-content">
            <div class="content setting-card-content">
              <figure class="img-icon-parts">
                <img :src="require('../../../assets/template/' + card.img)" draggable="false">
              </figure>
            </div>
            <div style="margin-top: -40px; text-align: right;">
              {{countConfirmParts(card.statusIdx, scenarioTable)}}/{{countParts(card.statusIdx, scenarioTable)}}
            </div>
          </div>
        </div>
      </div>
      <div class="card body-setting-template"
        :key="card.index"
        style="background: #dcdcdc; cursor: not-allowed;"
        v-else
      >
        <div>
          <div class="card-header">
            <p class="parts-name">{{card.name}}</p>
          </div>
          <div class="card-content">
            <div class="content setting-card-content">
              <figure class="img-icon-parts">
                <img :src="require('../../../assets/template/' + card.img)" draggable="false">
              </figure>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import cardList from '@/assets/json/master/scenario.json'
export default {
  data () {
    return {
      cardList: cardList
    }
  },
  props: {
    isParts: {
      type: Boolean,
      required: false
    },
    roboLock: {
      type: Boolean,
      required: false
    },
    scenarioTable: {
      type: Array,
      required: true
    }
  },
  methods: {
    countParts (idx, scenario) {
      let count = 0
      for (var s of scenario) {
        if (s.status+1 == idx) {
          count += 1
        }
      }
      return count
    },
    countConfirmParts (idx, scenario) {
      let count = 0
      for (var s of scenario) {
        if (s.status+1 == idx) {
          if (s.is_confirm) {
            count += 1
          }
        }
      }
      return count
    },
    countConfirmAll (scenario) {
      let count = 0
      for (var s of scenario) {
        if (s.is_confirm) {
          count += 1
        }
      }
      return count
    }
  }
}
</script>

<style lang="scss" scoped>
.body-setting-template {
  border-radius: 5px;
  margin: 10px;
  .setting-card-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .parts-name {
    padding: 6px;
    font-size: 12px;
    font-weight: 600;
  }
  .card-content {
    padding: 16px;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ScenarioParts.vue